<dx-data-grid [dataSource]="menuItemsDataSource"
              [showBorders]="true"
              [columns]="menuItemsColumns"
              (onSaving)="onPluginsGridSaving($event)"
              [columnAutoWidth]="true">
  <dxo-editing mode="form"
               [allowAdding]="true"
               [allowDeleting]="true"
               [allowUpdating]="true"></dxo-editing>
</dx-data-grid>
